
export const TOKEN_STORAGE_KEYSPACE = 'TOKEN_STORAGE_MANAGER';
export const TOKEN_TYPE_MARKET = 'MARKET';
export const TOKEN_TYPE_ACCOUNT = 'ACCOUNT';
export const TOKEN_TYPE_MARKET_INVITE = 'MARKET_INVITE';
